import { Component, ViewChild, ViewContainerRef, ChangeDetectionStrategy} from '@angular/core';
import {
  IAfterGuiAttachedParams,
  IDoesFilterPassParams,
  IFilterParams,
  IRowNode
} from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'filter-cell',
  template: `
    <div class="container">
      Contains:
      <input
        #input
        (ngModelChange)="onChange($event)"
        [ngModel]="text"
        class="form-control"
      />
    </div>
  `,
  styles: [
    `
      .container {
        border: 2px solid #bdc3c7;
        border-radius: 5px;
        background-color: #bdc3c7;
        width: 200px;
        height: 50px;
      }

      input {
        height: 20px;
      }
    `,
  ],
})
export class CustomFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  private valueGetter: any; // ag-grid ValueGetterFunc | value getter
  public text: string = '';

  @ViewChild('input', { read: ViewContainerRef }) public input;

  agInit(params: IFilterParams): void {
    this.params = params;
    this.valueGetter = params.valueGetter;
  }

  isFilterActive(): boolean {
    return this.text != null && this.text !== '';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let filterStatus = false;
    if (this.text && this.text.trim().length > 0) {
      this.text.trim()
        .toString()
        .split(',')
        .forEach((item) => {
          if (this.valueGetter({ ...this.params, node: params.node, data: params.node.data } as any)
            .toString()
            .toLowerCase().includes(item.toLowerCase())) {
            filterStatus = true;
            return filterStatus;
          }
          return false;
        });
    }
    return filterStatus
  }

  getModel(): any {
    return this.text;
  }

  setModel(model: any): void {
    this.text = model ? model.value : '';
  }

  afterGuiAttached(params: IAfterGuiAttachedParams): void {
    window.setTimeout(() => this.input.element.nativeElement.focus());
  }

  methodTakingValueFromFloatingFilter(value: any) {
    this.text = value;
    this.params.filterChangedCallback();
  }

  onChange(newValue: any) {
    if (this.text !== newValue) {
      this.text = newValue;
      this.params.filterChangedCallback();
    }
  }
}
